import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import {Button, IconButton, Tooltip} from "@mui/material";
import {ChevronRight} from "@mui/icons-material";

export function FieldTableExpanderColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);
    useEffect(() => {
        context.registerType({
            dataType: 'expander',
            width: () => '24px',
            className: () => 'column-centered column-button',
            noExport:true,
            readOnly:true,
            noSort: true,
            renderViewer: (props: FieldRendererProps<any,any>) => {
                return ( <IconButton color="primary" size="small" className={(props.isRowOpen ? ' rotate-90' : '')}
                                  onClick={() => props.toggleOpen?.()}><ChevronRight /></IconButton>);
            },
            renderHeader:(props:FieldRendererProps<any,any>) => {
                return <Tooltip title="Toggle All"><IconButton  size="small"
                    className={'uneditable ' + (props.openedAll ? ' rotate-90' : '')}
                    onClick={() => props.toggleOpenAll?.()}><ChevronRight/></IconButton></Tooltip>;
            }
        });
    }, [context]);
    return null;
}
